<template>
    <div  class="main-home">
       <div class="banner-conainer">
            <el-carousel height="843px" arrow="hover" @change="carouselChange">
                <el-carousel-item>
                    <img src="~@/assets/images/banner1.png" alt="">
                </el-carousel-item> 
                <el-carousel-item>
                    <img src="~@/assets/images/banner2.png" alt="">
                </el-carousel-item>
                <el-carousel-item>
                    <img src="~@/assets/images/banner3.png" alt="">
                </el-carousel-item>
            </el-carousel>
            <div class="banner-content-area" v-if="caseIndex == 0">
                <div class="banner-title">
                    <p>作品著作权代理登记</p>
                </div>
                <div class="banner-desc">
                    <p>依据《中华人民共和国著作权法及《作品自愿登记试行办法》</p>
                </div>
                <a href="http://home.bqshfw.com" target="_blank"><el-button>立即登记
                    <i class="el-icon-right"></i>
                </el-button></a>
            </div>
            <div class="banner-content-area " v-if="caseIndex == 1">
                <div class="banner-title">
                    <p>北京版权调解中心</p>
                </div>
                <div class="banner-desc">
                    <p>助推企业健康发展、维护当事人合法权益的便民服务</p>
                </div>
                <a href="#/mediate"><el-button>立即前往
                    <i class="el-icon-right"></i>
                </el-button></a>
            </div>
            <div class="banner-content-area case3" v-if="caseIndex == 2">
                <div class="banner-title">
                    <p>版权学习</p>
                </div>
                <div class="banner-desc">
                    <p>著作权是知识产权的一个重要组成部分，它是现代社会发展中不可缺少的一种法律制度</p>
                </div>
                <a href="#/study"><el-button>立即前往
                    <i class="el-icon-right"></i>
                </el-button></a>
            </div>
       </div>
       <div class="platform-statistics">
            <ul>
                <li>
                    <p class="num">989338</p>
                    <p class="name">认证数量</p>
                </li>
                <li>
                    <p class="num">964283</p>
                    <p class="name">受理数量</p>
                </li>
                <li>
                    <p class="num">568914</p>
                    <p class="name">出证数量</p>
                </li>
                <li>
                    <p class="num">5475</p>
                    <p class="name">著作人数量</p>
                </li>
            </ul>
       </div>
       <div class="platform-introduce">
            <div class="title">
                <p>版权社会服务体系</p>
            </div>
            <div class="introduce">
                <p>版权工作“十四五”规划指出：“完善版权社会服务体系，优化版权社会服务体制机制，创新工作方式方法，引导和规范版权社会服务机构建设，全面提升版权社会服务能力”。“提升版权社会组织服务水平。充分利用各种社会资源和力量，发挥各级各类版权协会、版权保护中心、版权交易中心、版权服务站、行业版权联盟、版权代理机构和高校、科研院所等单位的作用，加强对版权社会组织的支持和管理，引导版权社会组织在资产管理、版权运营、鉴定评估、版权金融、监测预警、宣传培训、法律服务、纠纷调处等方面发挥专业性优势。支持版权社会组织之间的交流合作，推进版权社会组织的规范化发展。</p>
            </div>
            <!-- <div class="view-more">
                <div class="btn">view more</div>
            </div> -->
            <div class="vertical-text">
                <p class="system">SYSTEM</p>
                <p class="service">SERVICE</p>
            </div>
       </div>

       <div class="platform-service">
            <ul>
                <li class="service-first">
                    <p class="name-cn">平台服务</p>
                    <p class="name-en">PLATFORM SERVICE</p>
                </li>
                <li class="service-item" @click="serviceActive('register')">
                    <div class="item-img">
                        <img src="~@/assets/images/ptfw_img_1.png">
                    </div>
                    <div class="item-name" >
                        <p class="name-cn">版权登记</p>
                        <p class="name-en">Copyright registration</p>
                        <span class="service-icon">
                            <svg width="26" height="24" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1243_42)">
                                <path d="M21.3408 11.9H3.40674V12.9H21.5518L17.965 16.3L18.7034 17L23.4507 12.5L18.7034 8L17.965 8.7L21.3408 11.9Z"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1243_42">
                                <rect width="25.3187" height="24" fill="white" transform="translate(0.241699)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </div>
                </li>
                <li class="service-item" @click="serviceActive('query')">
                    <div class="item-img">
                        <img src="~@/assets/images/ptfw_img_2.png">
                    </div>
                    <div class="item-name">
                        <p class="name-cn">版权查询</p>
                        <p class="name-en">Copyright inquiry</p>
                        <span class="service-icon">
                            <svg width="26" height="24" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1243_42)">
                                <path d="M21.3408 11.9H3.40674V12.9H21.5518L17.965 16.3L18.7034 17L23.4507 12.5L18.7034 8L17.965 8.7L21.3408 11.9Z"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1243_42">
                                <rect width="25.3187" height="24" fill="white" transform="translate(0.241699)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </div>
                </li>
                <li class="service-item" @click="serviceActive('mediate')">
                    <div class="item-img">
                        <img src="~@/assets/images/ptfw_img_3.png">
                    </div>
                    <div class="item-name" >
                        <p class="name-cn">版权调解</p>
                        <p class="name-en">Copyright mediation</p>
                        <span class="service-icon">
                            <svg width="26" height="24" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1243_42)">
                                <path d="M21.3408 11.9H3.40674V12.9H21.5518L17.965 16.3L18.7034 17L23.4507 12.5L18.7034 8L17.965 8.7L21.3408 11.9Z"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1243_42">
                                <rect width="25.3187" height="24" fill="white" transform="translate(0.241699)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </div>
                </li>
                <li class="service-item" @click="serviceActive('study')">
                    <div class="item-img">
                        <img src="~@/assets/images/ptfw_img_4.png">
                    </div>
                    <div class="item-name">
                        <p class="name-cn">版权学习</p>
                        <p class="name-en">Copyright Learning</p>
                        <span class="service-icon">
                            <svg width="26" height="24" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1243_42)">
                                <path d="M21.3408 11.9H3.40674V12.9H21.5518L17.965 16.3L18.7034 17L23.4507 12.5L18.7034 8L17.965 8.7L21.3408 11.9Z"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1243_42">
                                <rect width="25.3187" height="24" fill="white" transform="translate(0.241699)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </div>
                </li>
                <li class="service-item" @click="serviceActive('activity')">
                    <div class="item-img">
                        <img src="~@/assets/images/ptfw_img_5.png">
                    </div>
                    <div class="item-name">
                        <p class="name-cn">版权活动</p>
                        <p class="name-en">Copyright activity</p>
                        <span class="service-icon">
                            <svg width="26" height="24" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1243_42)">
                                <path d="M21.3408 11.9H3.40674V12.9H21.5518L17.965 16.3L18.7034 17L23.4507 12.5L18.7034 8L17.965 8.7L21.3408 11.9Z"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1243_42">
                                <rect width="25.3187" height="24" fill="white" transform="translate(0.241699)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </div>
                </li>
            </ul>
       </div>
       <div class="doyou_certification">
             <div class="item-title">
                <p class="name-cn">为什么要进行版权认证</p>
                <p class="name-en">WHY DO YOU NEED COPYRIGHT CERTIFICATION?</p>
             </div>
             <div class="after"></div>
             <div class="certification-line">
                <ul>
                    <li>明确权利归属</li>
                    <li>主张权利的初步证明</li>
                    <li>知识产权保护的有力补充</li>
                    <li>增加无形资产评估价值</li>
                    <li>增强市场竞争力</li>
                    <li>降低权利流转中的经济风险</li>
                </ul>
             </div>
       </div>
       <div class="certification-advantage">
            <div style="width: 1200px; margin: 0 auto;display: flex;" class="cam-advantage">
                <div class="content">
                    <div class="title">
                        <p class="name-cn">认证优势</p>
                        <p class="name-en">CERTIFICATION ADVANTAGE</p>
                    </div>
                    <div class="after"></div>
                </div>
                <div class="content-item">
                    <p>1.权威机构认定，双重确权保障：依据《作品著作权认证办法》、《中华人民共和国公证法》及《中华人名共和国电子签名法》， 首都版权协会签发《作品认证证书》，北京国信公证处出具《电子数据保管函》，传统公证可作为诉讼过程中最有效力的直接证据。</p>
                    <p>2.人机结合审查，避免作品重复认证：提取作品唯一特征值，作品及相关作品权属信息经技术筛查和人工复查，保证信息完整、合 规且不被篡改，避免作品重复认证造成权属混乱。</p>
                    <p>3.简单快捷，价格低廉：支持全天候自主操作，1个工作日快速出证。</p>
                </div>
                <div class="right-img">
                    <!-- <img src="@/assets/images/advantage-right.png"/> -->
                </div>
            </div>
       </div>
       <div class="copyrigh_supports">
            <div class="item-title">
                <p class="name-cn">版权登记支持作品类型</p>
                <p class="name-en">COPYRIGHT REGISTRATION SUPPORTS TYPES OF WORKS</p>
             </div>
             <div class="after"></div>
             <div class="work-items">
                <ul>
                    <li>文学作品</li>
                    <li>口述作品</li>
                    <li>音乐、戏剧、曲艺、舞 蹈、杂技艺术作品</li>
                    <li>美术、建筑作品</li>
                    <li>摄影作品</li>
                    <li>电影作品和类似摄影电影的方法创作的作品</li>
                    <li>工艺设计图、产品设计图、地图、示意图等图形作品和模型作品</li>
                    <li>法律、行政法规规定的其他作品</li>
                </ul>
             </div>
       </div>

       <div class="copyrigh_detection">
            <div class="item-title">
                <p class="name-cn">检测类型及范围</p>
                <p class="name-en">本系统监测互联网特定范围图片、文字、音频、视频全作品等作品</p>
             </div>
             <div class="after"></div>
             <div class="detection-items">
                <ul>
                    <li>
                        <div class="top">
                            <img src="@/assets/images/detection-item1.png"/>
                        </div>
                        <div class="bottom">
                            <p>图：摄影、漫画、设计图等</p>
                            <p>重点监测范围包含：百度图片，搜狗图片，360图片，谷歌图片及各大图片素材网站、动漫平台、自媒体平台、社交平台、资讯平台等。</p>
                        </div>
                    </li>
                    <li>
                        <div class="top">
                            <img src="@/assets/images/detection-item2.png"/>
                        </div>
                        <div class="bottom">
                            <p>视频:电影、短片、广告等</p>
                            <p>重点监测范围包含：腾讯视频、爱奇艺、优酷，抖音、火山、西瓜、快手、秒拍、斗鱼等主流短视平台及直播平台、资讯平台等。</p>
                        </div>
                    </li>
                    <li>
                        <div class="top">
                            <img src="@/assets/images/detection-item3.png"/>
                        </div>
                        <div class="bottom">
                            <p>文:小说、诗词、论文等</p>
                            <p>重点监测范围包含：百度，搜狗等搜索引擎及微信公众号、微博、今日头条、百家号、大鱼号、知乎、各大自媒体平台及网络文学平台、资讯平台等。</p>
                        </div>
                    </li>
                    <li>
                        <div class="top">
                            <img src="@/assets/images/detection-item4.png"/>
                        </div>
                        <div class="bottom">
                            <p>音乐: 歌曲、音乐素材、口语等</p>
                            <p>重点监测范围包含：热门播放器、主流短视频及直播平台等。</p>
                        </div>
                    </li>
                     
                </ul>
             </div>
       </div>
       <div class="obtain_evidence">
            <div class="item-title">
                <p class="name-cn">取证维权</p>
                <p class="name-en">Multi-channel rights protection</p>
             </div>
             <div class="after"></div>
             <div class="evidence-items">
                <ul>
                    <li>
                        <img src="~@/assets/images/evidence-item1.png">
                        <p>著作权调解</p>
                    </li>
                    <li>
                        <img src="~@/assets/images/evidence-item2.png">
                        <p>非法网站关停</p>
                    </li>
                    <li>
                        <img src="~@/assets/images/evidence-item3.png">
                        <p>快速下线绿色通道</p>
                    </li>
                    <li>
                        <img src="~@/assets/images/evidence-item4.png">
                        <p>应用市场维权通道</p>
                    </li>
                    <li>
                        <img src="~@/assets/images/evidence-item5.png">
                        <p>代理行政投诉</p>
                    </li>
                    <li>
                        <img src="~@/assets/images/evidence-item6.png">
                        <p>代理民事诉讼</p>
                    </li>
                    <li>
                        <img src="~@/assets/images/evidence-item7.png">
                        <p>联合启动刑事案件调查</p>
                    </li>

                </ul>
            </div>
            <div class="cooperate">
                <div class="left">
                    <div class="item-title">
                        <p class="name-cn">合作伙伴</p>
                        <p class="name-en">COOPERATIVE PARTNER</p>
                    </div>
                    <div class="after"></div>
                </div>
                <div class="right">
                    <ul>
                        <li v-for="item in cooperate" @mouseenter="cooperateMouseenter(item)" @mouseleave="cooperateMouseleave(item)">
                            <img :src="item.isHover?item.hover:item.url"/>
                        </li>
                    </ul>
                </div>
            </div>
       </div>
    </div>
</template>

<script>
   import { addOpportunity } from '@/api/business.js';
import router from '@/router';
import service from '@/utils/request';

    export default {
        data () {
            return {
                validatePhoneFail:false,
                validateText:'',
                activeIndex:0,
                activeCarouselIndex:0,
                caseIndex:0,
                cooperate:[],
                form:{
                    content:'',
                    phone:''
                },
                


            }
        },
        mounted() {
            this.init();
            // 解决锚点刷新时页面404
            // this.$router.push('/')
        },
        methods: {

            init(){
                for(var i=1;i < 12;i++){
                    this.cooperate.push({
                        url: require(`../../assets/images/cooperate/cooperate-item${i}-2.png`),
                        hover: require(`../../assets/images/cooperate/cooperate-item${i}-1.png`),
                        isHover:false
                    })
                }
                
            },
            handlePage(route){
                this.$router.push('/'+ route)
            },
            carouselChange(key){
                console.log("carouselChange",key)
                this.caseIndex = key;
            },
            cooperateMouseenter(item){
                item.isHover = true;
            },
            cooperateMouseleave(item){
                item.isHover = false;
            },
            serviceActive(path){
                this.$router.push('/'+ path)
            }
            
          
        },
        computed: {

        },
        watch: {
            activeIndex(newValue, oldValue){
                if(newValue){
                    this.loadImgUrl = require('../../assets/images/menu-system'+(newValue)+ '.png')
                }
            }
        }
    }
</script>

<style lang="less">
.main-home{
    width:100%;
    .banner-conainer{
        // background-image: url('../../assets/images/banner.png');
        height: 843px;
        background-size: 100%;
        overflow: hidden;
        background-repeat: no-repeat;
        margin-top:68px;
        position: relative;
        .el-carousel__item{
            z-index: -1;
            img{
                width:100%;
                height:100%;
            }
        }
        .banner-content-area.case3{
            width: 800px;
            left: calc((100% - 800px) / 2);
            text-align: center;
            .el-button{
                border: 1px solid #000000
            }
        }
        .banner-content-area{
            position: absolute;
            left:2rem;
            top:3.3rem;
            color: #fff;
            text-align: left;
            .banner-title{
                p{
                    font-family: PingFang HK;
                    font-size: 86px;
                    font-weight: 400;
                    line-height: 120.4px;

                }
            }
            .banner-desc{
                margin-top:0.3rem;
                p{
                    font-size: 26px;
                    font-family: 'Source Han Sans CN';
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 42px;
                }
            }
            .el-button{
                width: 170px;
                height: 54px;
                background: #fff;
                border-radius: 27px;
                font-size: 16px;
                font-family: 'Source Han Sans CN';
                font-weight: 700;
                color: #333333;
                border: none;
                margin-top:0.46rem;
            }
        }
        .main-banner{
            width: 1200px;
            margin: 0 auto;
            margin-top: 130px;
        }
        .block-text{
            .block-title{
                font-size: 50px;
                font-family: Alibaba PuHuiTi;
                font-weight: bold;
                color: #1E1E1E;
                line-height: 76px;
                width: 670px;
                text-align: left;
            }
            .block-desc{
                width: 570px;
                // height: 78px;
                font-size: 16px;
                font-family: Alibaba PuHuiTi;
                font-weight: 400;
                color: #3D3D3D;
                line-height: 30px;
                // opacity: 0.95;
                text-align: left;
                margin-top:33px;
            }
        }
    }
    .platform-statistics{
        width: 1200px;
        margin: 0 auto;
        height: 200px;
        padding: 50px 0;
        ul {
            display: flex;
            justify-content: space-evenly;
            li{
                width: 195px;
                height: 100px;
                position: relative;
                .num{
                    font-family: PingFang SC;
                    font-size: 50px;
                    font-weight: 400;
                    line-height: 70px;
                    text-align: center;
                    color: #206BD1;
                }
                .num::after{
                    content: "+";
                    position: absolute;
                    right: -12px;
                    top:0;
                    font-size: 12px;
                    line-height: 12px;
                    color: #B3B3B3;

                }
                .name{
                    font-family: PingFang SC;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 19.6px;
                    text-align: center;
                    color: #999999;
                }
            }
            li:nth-child(n + 2)::after{
                content: "";
                width: 1px;
                height: 100px;
                background-color: #A3A3A3;
                position: absolute;
                left: -50px;
                top:0;
            }
        }
    }
    .platform-introduce{
        height: 334px;
        width: 1084px;
        margin: 0 auto;
        text-align: left;
        position: relative;
        padding: 50px 0;
        .title{
            width: 814px;
            font-family: Source Han Sans CN;
            font-size: 24px;
            font-weight: 700;
            line-height: 36px;
            color: #333333;
        }
        .introduce{
            p{
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 30px;
                text-indent: 4ch;
                color: #999999;
            }
            width: 814px;
            padding: 50px 0;
        }
        .view-more{
            .btn{
                font-family: PingFang SC;
                width: 156px;
                height: 54px;
                line-height: 54px;
                border-radius: 27px;
                border: 1px solid #D3D3D3;
                text-align: center;
                color: #999999;
                user-select: none;
                cursor: pointer;
            }
        }
        .vertical-text{
            position: absolute;
            right: -90px;
            top:100px;
            transform: rotate(270deg);
            width: 334px;
            .system{
                font-family: PingFang SC;
                font-size: 40px;
                font-weight: 600;
                line-height: 56px;
                color: #E3E3E3;
            }
            .service{
                color: #CACACA;
                font-family: PingFang SC;
                font-size: 68px;
                font-weight: 600;
                line-height: 95.2px;
                text-align: right;

            }
        }
    }
    .platform-service{
        font-family: PingFang SC;
        width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 50px 0;
        ul{
            display: flex;
            flex-wrap: wrap;
        }
        li{
            width: 384px;
            height: 278px;
            position: relative;
        }
        li:nth-child(3n - 1),li:nth-child(3n){
            margin-left: 24px;
        }
        li:nth-child(n+4){
            margin-top: 24px;
        }
        .service-first{
            .name-cn{
                font-size: 24px;
                font-weight: 400;
                line-height: 33.6px;
                color: #333333;
            }
            .name-en{
                font-size: 24px;
                font-weight: 600;
                line-height: 33.6px;
                color: #E5E5E6;
                
            }
        }
        .service-first::after{
            content: "";
            position: absolute;
            left:0;
            top:80px;
            background-color: #D9D9D9;
            width: 24px;
            height: 4px;
        }
        .service-item{
            font-family: Source Han Sans CN;
            cursor: pointer;
            border-bottom: 1px solid #D9D9D9;
            user-select: none;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            .item-img{
                width: 384px;
                height: 200px;
                overflow: hidden;
                img{
                    transition: .5s;
                }
            }
            .item-name{
                height: calc(100% - 200px);
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding-left: 20px;
                position: relative;
            }
            .name-cn{
                font-size: 14px;
                font-weight: 700;
                line-height: 21px;
                color: #666666;
            }
            .name-en{
                font-size: 12px;
                font-weight: 700;
                line-height: 18px;
                text-align: left;
                color: #999999;
                text-transform: uppercase;
            }
            .service-icon{
                position: absolute;
                font-size: 30px;
                line-height: 40px;
                top:20px;
                right: 20px;
                fill: #E5E5E5;
            }

        }
        .service-item:hover{
            border-bottom-color: #333333;
            .item-img img{
                transform: scale(1.1);
            }
            .service-icon{
                fill: #333333;
            }
            //
            // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
        }
    }
    .doyou_certification{
        padding: 50px 0;
        text-align: left;
        width: 1200px;
        margin: 0 auto;
        font-family: PingFang SC;
         
        .certification-line{
            position: relative;
            ul{
                display: flex;
                justify-content: space-evenly;
                padding: 20px 0;
                li{
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 19.6px;
                    color: #777777;
                    position: relative;
                    padding-top: 20px;
                }
                li::after{
                    content: "";
                    position: absolute;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background-color: #206BD1;
                    top: 0;
                    left: calc((100% - 10px) / 2);
                    z-index: 1;
                }
            }
            ul::after{
                content: "";
                position: absolute;
                height: 1px;
                width: 100%;
                background-color: #999999;
                z-index: 0;
                top: 25px;
            }
        }
    }
    .certification-advantage{
        height: 200px;
        width: 100%;
        background-color: #206BD1;
        position: relative;
        margin-bottom: 50px;
        overflow: hidden;
        text-align: left;
        min-width: 1200px;
        .content{
            width: 260px;
            .title{
            padding-top: 50px;
            .name-cn{
                font-size: 18px;
                font-weight: 400;
                line-height: 25px;
                color: #F3F3F3;
            }
            .name-en{
                padding-top:10px ;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                color: #E5E5E6;
            }
        }
        }
        .content-item{
            width: 640px;
            display: flex;
            height: 200px;
            justify-content: center;
            flex-direction: column;
            p{
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 25.2px;
                color: #FFFFFF;
            }
        }
        .right-img{
            flex: 1;
            position: relative;
        }
    }
    .right-img::after{
        content: "";
        width: 616px;
        height: 200px;
        background-image: url("@/assets/images/advantage-right.png");
        position: absolute;
        top: 0;
        left: 50px;

    }
    .right-img::before{
        content: "";
        background-color: #fff;
        position: absolute;
        top: -50px;
        left:100px;
        transform: rotate(209deg);

        width: 13px;
        height: 300px;
        z-index: 3;
    }
    .copyrigh_supports{
        width: 1200px;
        text-align: left;
        margin:  0 auto;
        padding:  50px 0;
        .work-items{
            padding-top: 20px;
            ul {
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 282px;
                    height: 282px;
                    background-image: url("@/assets/images/work-item-bg.png");
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #FFFFFF;
                    font-size: 24px;
                    padding: 0 20px;
                    box-sizing: border-box;
                    text-align: center;
                    cursor: pointer;
                    user-select: none;
                }
                li:nth-child(n + 5){
                    margin-top: 24px;
                }
                li:nth-child(4n - 1),li:nth-child(4n - 2),li:nth-child(4n){
                    margin-left: 24px;
                }
            }
        }
    }
    .copyrigh_detection{
        width: 1200px;
        text-align: left;
        margin:  0 auto;
        padding:  50px 0;
        .detection-items{
            padding-top: 20px;
            ul {
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 282px;
                    height: 380px;
                    .top{
                        height: 98px;
                        width: 100%;
                        text-align: center;
                        img{
                            width: 206px;
                            width: 206px;
                        }
                    }
                    .bottom{
                        width: 282px;
                        height: 282px;
                        background-color: #EDF4FB;
                        box-sizing: border-box;
                        padding: 110px 18px 0 18px;
                        font-family: PingFang SC;
                        p:nth-child(1){
                            font-size: 18px;
                            font-weight: 400;
                            line-height: 50px;
                            color: #666666;
                        }
                        p:nth-child(2){
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                            color: #939393;
                        }
                    }
                }
                li:nth-child(4n - 1),li:nth-child(4n - 2),li:nth-child(4n){
                    margin-left: 24px;
                }
            }
        }
    }
    .obtain_evidence{
        width: 1200px;
        text-align: left;
        margin:  0 auto;
        padding:  50px 0;
        .evidence-items{
            padding-top: 20px;
            ul {
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 150px;
                    height: 276px;
                    position: relative;
                    user-select: none;
                    p{
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 22.4px;
                        color: #FFFFFF;
                        padding: 0 15px;
                        position: absolute;
                        left: 0;
                        top: 20px;
                    }
                }
                
                li:nth-child(n + 2){
                    margin-left: 25px;
                }
            }
        }
    }
    .cooperate{
        width: 1200px;
        text-align: left;
        margin:  0 auto;
        padding:  50px 0;
        display: flex;
        .left{
            flex: 1;
        }
        .right{
            width: 728px;
            ul {
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 232px;
                    height: 106px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                li:hover{
                    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
                }
                li:nth-child(3n - 1),li:nth-child(3n){
                    margin-left: 16px;
                }
                li:nth-child(n+4){
                    margin-top: 16px;
                }
            }
        }
    }

    .after{padding: 10px 0;position: relative;}
    .after::after{
        content: "";
        position: absolute;
        left:0;
        top:10px;
        background-color: #D9D9D9;
        width: 24px;
        height: 4px;
    }
    .item-title{
        .name-cn{
            font-size: 24px;
            font-weight: 400;
            line-height: 33.6px;
            color: #333;
        }
        .name-en{
            padding-top:10px ;
            font-size: 24px;
            font-weight: 600;
            line-height: 33.6px;
            color: #E5E5E6;
        }
    }
}


</style>